export type HomeRenovationHighlight = {
  id: string
  label: string
}

export const homeRenovationHighlights: HomeRenovationHighlight[] = [
  { id: 'property-value', label: 'Até 60% do valor do imóvel' },
  { id: 'payment-term', label: 'Prazos de até 240 meses' },
  { id: 'lower-rates', label: 'Taxas até 12x mais baixas' },
  { id: 'free-use', label: 'Uso livre do recurso' }
]
